(() => {
  function initArticleEnhancements() {
const articleBody = document.querySelector('.article-template-content');
  const articleTemplate = document.querySelector('.article-template');
  const progressBar = document.querySelector('.article-reading-progress span');

  if (articleBody) {
    articleBody.querySelectorAll('table').forEach((table) => {
      if (table.parentElement.classList.contains('article-table-scroll')) return;
      const wrapper = document.createElement('div');
      wrapper.className = 'article-table-scroll';
      wrapper.setAttribute('role', 'region');
      wrapper.setAttribute('tabindex', '0');
      table.before(wrapper);
      wrapper.append(table);
    });

    articleBody.querySelectorAll('img').forEach((image) => {
      image.loading = 'lazy';
      image.decoding = 'async';
      if (!image.hasAttribute('alt')) {
        const heading = image.previousElementSibling?.closest('h2, h3') || articleBody.querySelector('h2, h3');
        image.alt = heading?.textContent.trim() || '';
      }
    });

    const headings = [...articleBody.querySelectorAll('h1, h2, h3, h4')].filter((heading) => heading.textContent.trim());
    const tableOfContents = articleTemplate?.querySelector('.article-toc');
    if (tableOfContents && headings.length > 0) {
      const list = tableOfContents.querySelector('ol');
      headings.forEach((heading, index) => {
        if (!heading.id) heading.id = `article-section-${index + 1}`;
        heading.style.scrollMarginTop = '110px';
        const item = document.createElement('li');
        if (heading.tagName === 'H3' || heading.tagName === 'H4') item.className = 'article-toc__subitem';
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent.trim();
        item.append(link);
        list.append(item);
      });
      tableOfContents.hidden = false;
    }
  }

  if (articleTemplate && progressBar) {
    const updateReadingProgress = () => {
      const bounds = articleTemplate.getBoundingClientRect();
      const distance = Math.max(articleTemplate.offsetHeight - window.innerHeight, 1);
      const progress = Math.min(Math.max(-bounds.top / distance, 0), 1);
      progressBar.style.transform = `scaleX(${progress})`;
    };
    updateReadingProgress();
    window.addEventListener('scroll', updateReadingProgress, { passive: true });
    window.addEventListener('resize', updateReadingProgress);
  }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initArticleEnhancements, { once: true });
  } else {
    initArticleEnhancements();
  }
  document.addEventListener('shopify:section:load', initArticleEnhancements);
})();

